import React, { Component } from 'react';
import PageComponentForm from '../PageComponentForm';

export class UpdatePageComponent extends Component {
    static displayName = UpdatePageComponent.name;

    constructor(props) {
        super(props);
        this.state = {
            pageId: this.props.match.params.pageId
        };
    }

    render() {
        return (
            <PageComponentForm pageId={this.state.pageId} />
        );
    }
}
